import { ReactNode } from "react";

type KpiCardProps = {
  label: string;
  value?: string;
  children?: ReactNode;
};

export default function KpiCard({ label, value, children }: KpiCardProps) {
  return (
    <div className="flex-1 min-w-[180px] bg-gray-900 text-white rounded-lg shadow-sm px-4 py-3">
      <div className="text-xs uppercase tracking-wide text-gray-400">{label}</div>
      {value && <div className="mt-1 text-2xl font-semibold">{value}</div>}
      {children && <div className="mt-2 text-sm">{children}</div>}
    </div>
  );
}


